<template>
<div class="box">
  <header class="header">
    <div>
      <span class="icon" v-if="icon"><i :class="'fa ' + icon" style="font-size: 16px"></i></span>
      <span>{{iconLabel}}</span>
    </div>
    <div v-if="voltage" :style="'color:' + color">{{ voltage }}</div>
  </header>
  <div class="body" :style="'color:' + color">
    <span class="value">{{ value }}</span><span class="title">{{ title }}</span>
  </div>
  <footer class="footer">
    {{ current }}
  </footer>
</div>
</template>

<script>
export default {
  name: "custom-box",
  props: ["title", "value", "color", "voltage", "current", "icon", "iconLabel"],
  data() {
    return {};
  },
  computed: {},
  components: {},
  methods: {},
  mounted() {}
};
</script>

<style lang="scss" scoped>
.box {
  background-color: #f9f9f9;
  border: 1px solid #f0f0f0;
  padding: 20px;
  height: 220px;
  display: flex;
  flex-direction: column;
}

.header {
  display: flex;
  justify-content: space-between;
  color: #999999;
  font-size: 13px;
}

.footer {
  text-align: right;
  color: #f7ab3e;
}

.body {
  display: flex;
  flex-grow: grow;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 100%;
}

.value {
  font-size: 42px;
}

.icon {
  margin-right: 3px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/dashboard/components/customBox.vue